import PhoneButton from "./PhoneButton"

const MainTopMessage = () => {
  return (
    <div className="py-6 tn:py-8 xs:py-10 sm:py-12 md:py-14 lg:py-16 my-10 tn:my-12 xs:my-16 sm:my-20 md:my-24 lg:my-28 xl:my-32 2xl:my-36 bg-[#F8F8F8]">
      <h2 className="px-4 mb-5 tn:mb-6 sm:mb-7 md:mb-8 text-xl tn:text-2xl sm:text-3xl md:text-4xl tracking-[.20em] tn:leading-[2.1rem] xs:leading-[2.4rem] sm:leading-[2.7rem] md:leading-[3rem]">
        вул. Соборна, 16
        <br />
        10:00 - 18:00
        <br />
        БЕЗ ВИХІДНИХ
      </h2>

      <PhoneButton></PhoneButton>
    </div>
  )
}

export default MainTopMessage
